import { createSelector } from 'reselect';
import i18n from '../utils/i18n';
const getQuestionsAndAnswers = (state) => state.bodyscale?.data.bodyAssessment.questionsAndAnswers;
const getCurrentQuestion = (state) => state.bodyscale?.data.bodyAssessment.currentQuestion;
const getAthleteMode = (state) => state.bodyscale?.data.bodyAssessment.results;
const getScaleScanStats = (state) => state.bodyscale?.data.scaleScanStats;
const getBodyscanAssessmentProgress = (state) => state.bodyscale?.view.progress;
const getBodyscanAssessmentquestionsAndAnswers = (state) => state.bodyscale?.data.bodyAssessment.questionsAndAnswers;
const getIsScanContinuingFromWeightTarget = (state) => state.bodyscale?.view.isScanContinuingFromWeightTarget;
const getBodyWeightFromScaleScanStats = (state) => state.bodyscale?.data.scaleScanStats.totalBodyWeight.valAndUnit;
const getIsReviewingTargetAndSavingScan = (state) => state.bodyscale?.view.isReviewingTargetAndSavingScan;
const getIsRemovingBodyScale = (state) => state.bodyscale?.view.isRemovingBodyScale;

import { getTrackingGaugeDataFromStats } from '../utils/trackingGaugeData';

export const getQuestionStep = createSelector(
    [getQuestionsAndAnswers, getCurrentQuestion],
    (questionsAndAnswers, currentQuestion) => {
        return !questionsAndAnswers || !currentQuestion ? null :
            questionsAndAnswers.findIndex((x) => x.questionId === currentQuestion.questionId) + 1;
    },
);

export const selectAthleteMode = createSelector(
    [getAthleteMode],
    ((results) => results?.athleteMode === 'no' ? false : true),
);


export const bodyScanStatsGaugeSelector = createSelector(
  [getScaleScanStats],
  (scaleScanStats) => {
      if (!scaleScanStats) {
          return {};
      }
      const { totalBodyWeight, muscleMass, fat } = scaleScanStats;
      return {
       totalBodyWeightTrackingGaugeData: {
           data: getTrackingGaugeDataFromStats(totalBodyWeight.rangePercentages),
           valAndUnit: totalBodyWeight.valAndUnit,
           valuePercent: totalBodyWeight.valuePercent,
           label: i18n.t('bodyscan:totalBodyWeight'),
       },
       muscleMassTrackingGaugeData: {
           data: getTrackingGaugeDataFromStats(muscleMass.rangePercentages),
           valAndUnit: muscleMass.valAndUnit,
           valuePercent: muscleMass.valuePercent,
           label: i18n.t('bodyscan:muscleMass'),
       },
       fatTrackingGaugeData: {
           data: getTrackingGaugeDataFromStats(fat.rangePercentages),
           valAndUnit: fat.valAndUnit,
           valuePercent: fat.valuePercent,
           label: i18n.t('bodyscan:fatPercentage'),
       },
    };
  },
);

export const bodyscanAssessmentProgressSelector = createSelector(
    [getBodyscanAssessmentProgress],
    (process) => process,
);

export const bodyscanAssessmentquestionsAndAnswersSelector = createSelector(
    [getBodyscanAssessmentquestionsAndAnswers],
    (bodyscanAssessmentquestionsAndAnswers) => bodyscanAssessmentquestionsAndAnswers,
);

export const selectIsScanContinuingFromWeightTarget = createSelector(
    [getIsScanContinuingFromWeightTarget],
    (isScanContinuingFromWeightTarget) => isScanContinuingFromWeightTarget,
);

export const selectBodyWeightFromScaleScanStats = createSelector(
    [getBodyWeightFromScaleScanStats],
    (valAndUnit: string) => {
        return parseFloat(valAndUnit.substring(0, valAndUnit.length - 2));
    },
);

export const selectIsReviewingTargetAndSavingScan = createSelector(
    [getIsReviewingTargetAndSavingScan],
    (isReviewingTargetAndSavingScan) => isReviewingTargetAndSavingScan,
);

export const selectIsRemovingBodyScale = createSelector(
    [getIsRemovingBodyScale],
    (isRemovingBodyScale) => isRemovingBodyScale,
);
